module.exports = __webpack_public_path__ + "static/media/gallery-wide-2.6c48ad51.jpg";